// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export { createLoggerContext, } from "./logger.js";
//# sourceMappingURL=internal.js.map